/**
 * Single source of truth for Enterprise LaunchDarkly flags.
 *
 * To add a new flag:
 *   1. Add it here with its default value
 *   2. Keep the key exactly aligned with LaunchDarkly
 */
export const FLAGS = {
  enterpriseAppEnabled: false,
  i18nEnabled: false,
} as const satisfies Record<
  string,
  boolean | string | number | { [key: string]: boolean }
>;

export type Flags = typeof FLAGS;
export type FlagKey = keyof Flags;

type Widen<T> = T extends boolean
  ? boolean
  : T extends string
    ? string
    : T extends number
      ? number
      : { [K in keyof T]: Widen<T[K]> };

export type FlagValues = { [K in FlagKey]: Widen<Flags[K]> };
